// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { list, $delete, createOrUpdate, get } from "./operations.js";
export {
  CapabilitiesListOptionalParams,
  CapabilitiesDeleteOptionalParams,
  CapabilitiesCreateOrUpdateOptionalParams,
  CapabilitiesGetOptionalParams,
} from "./options.js";
